'use client'

import { DirectionIcon, Typography } from '@/shared/ui/atoms'
import { useLocale, useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

const TreatmentCaseMoreButton = () => {
  const t = useTranslations()
  const locale = useLocale()
  return (
    <Link href={`/${locale}/treatment-case`} className="mt-4 flex items-center justify-center w-full border border-gray-200 rounded-[12px] py-2.5">
      <Typography size={15} lineHeight={22} className="text-gray-900 font-medium">
        {t("treatmentCaseMoreButton.text")}
      </Typography>
      <span className="relative w-[41px] h-[22px]">
        <Image src="/icons/treatment-case-more-btn.png" alt="arrow-right" fill sizes="41px 22px" className="object-cover" />
      </span>
      <DirectionIcon size={16} className="text-gray-400" rotate={270} />
    </Link>
  )
}

export default TreatmentCaseMoreButton